import React from 'react';
import './WysiwygComponent.css';

const LazyWysiwygEditor = React.lazy(() =>
    import(/* webpackChunkName: "wysiwyg-editor" */ './WysiwygComponent.editor')
);

function WysiwygComponent(props) {
    return (
        <React.Suspense
            fallback={
                <div className="content-wysiwyg">
                    <div style={props.style ? props.style : {}} className="wysiwyg">
                        <p className="wysiwyg-helper-text">Chargement de l'editeur...</p>
                    </div>
                </div>
            }
        >
            <LazyWysiwygEditor {...props} />
        </React.Suspense>
    );
}

export default WysiwygComponent;
